import Vue from 'vue';
import { formatNum } from '@/util/number';

Vue.filter('toKnot', (value) => {
  if (value === undefined) return '';
  return formatNum((value / 1.852), 2);
});

Vue.filter('toKM', (value) => {
  if (value === undefined) return '';
  return formatNum((value / 1000), 2);
});

Vue.filter('toMiles', (value) => {
  if (value === undefined) return '';
  return formatNum((value * 0.00062137), 2);
});

Vue.filter('toNM', (value) => {
  if (value === undefined) return '';
  return formatNum((value * 0.00053996), 2);
});
